import Banner from './Banner.js';
export default Banner;